module.exports = __webpack_public_path__ + "img/carshinaused_23.229bb4a5.jpg";